import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { Input, InputProps, Typography } from '@mui/material';
import theme from '../../../styles/theme';

const Wrapper = styled.div`
  padding-top: 20px;
`;

const CustomInput = styled(Input)`
  & .root {
    width: 100%;
    padding: 0;
    border: 1px solid blue;
    border-radius: 3px;
    box-sizing: border-box;
    .input {
      color: ${({ error }) => (error ? theme.palette.error.main : '#A6A8AA')};
      font-size: 14px;
      padding: 10px;
      min-height: 37px;
      box-sizing: border-box;
      border: 1px;
    }
  }
`;

interface BravoTextFieldProps extends InputProps {
  label?: string;
}

// eslint-disable-next-line react/display-name
export const BravoTextField = forwardRef((props: BravoTextFieldProps, ref: React.Ref<HTMLInputElement>) => {
  const { label, value } = props;
  return (
    <Wrapper>
      <Typography variant="body1" align="left">
        {label}
      </Typography>
      <CustomInput classes={{ root: 'root', input: 'input' }} fullWidth {...props} ref={ref} value={value || ''} />
    </Wrapper>
  );
});
